import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import "bootstrap";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faBars,
  faCircleInfo,
  faEnvelope,
  faLocationDot,
  faPause,
  faPhone,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faBars,
  faCircleInfo,
  faEnvelope,
  faLocationDot,
  faPause,
  faPhone,
  faPlay,
);

createApp(App)
  .use(router)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
